import { render, staticRenderFns } from "./ApplicationPrimarySystem.vue?vue&type=template&id=4682c4f8&scoped=true"
import script from "./ApplicationPrimarySystem.vue?vue&type=script&lang=js"
export * from "./ApplicationPrimarySystem.vue?vue&type=script&lang=js"
import style0 from "./ApplicationPrimarySystem.vue?vue&type=style&index=0&id=4682c4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4682c4f8",
  null
  
)

export default component.exports